import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }



interface Props {
  backgroundStyle?: 'light' | 'dark' | 'custom'
  withSpacing?: boolean
  customStyles?: Record<string, string>
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSection',
  props: {
    backgroundStyle: { default: 'light' },
    withSpacing: { type: Boolean, default: true },
    customStyles: { default: () => ({}) }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass([
      'base-section',
      `bg-${_ctx.backgroundStyle}`,
      { 'with-spacing': _ctx.withSpacing }
    ]),
    style: _normalizeStyle(_ctx.customStyles)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 6))
}
}

})